import { SET_VIEW_CHANGE_CONTROL } from '../actions'

const reducer = (state = '', { type, payload } = {}) => {
  if (type === SET_VIEW_CHANGE_CONTROL) return payload

  return state
}

export default reducer
